import { useEffect, useState } from 'react';
import {
  checkOrganisationListed,
  ORGANIZATION_PREFIX_MIN_LENGTH,
} from '../../api/formService';
import { isOrganisationListed } from '../utils/oragnisationList';

const LISTED_CHECK_DEBOUNCE_MS = 400;

/**
 * Resolves whether the given organisation name matches a listed master record.
 * Uses backend exact match only after {@link ORGANIZATION_PREFIX_MIN_LENGTH} chars (debounced).
 */
export function useOrganisationListed(organisationName, apiCache) {
  const [isListed, setIsListed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const name = String(organisationName ?? '').trim();

    if (!name || name.length < ORGANIZATION_PREFIX_MIN_LENGTH) {
      setIsListed(false);
      return undefined;
    }

    if (isOrganisationListed(name, apiCache)) {
      setIsListed(true);
      return undefined;
    }

    const timer = setTimeout(() => {
      checkOrganisationListed(name)
        .then((result) => {
          if (!cancelled) {
            setIsListed(result);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setIsListed(false);
          }
        });
    }, LISTED_CHECK_DEBOUNCE_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [organisationName, apiCache]);

  return isListed;
}
